const musicGenres = [
    { id: 1, search_count: 100, name: "Rock", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 2, search_count: 100, name: "Pop", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 3, search_count: 100, name: "Jazz", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 4, search_count: 100, name: "Hip-Hop", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 5, search_count: 100, name: "Country", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 6, search_count: 100, name: "Rock", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 7, search_count: 100, name: "Pop", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 8, search_count: 100, name: "Jazz", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 9, search_count: 100, name: "Hip-Hop", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" },
    { id: 10, search_count: 100, name: "Country", image: "https://ago.ca/sites/default/files/styles/image_large/public/2022-05/IMG-5800.JPG?itok=cLSCe_V6" }
];

const getPopularGenresBySearchCount = () => {
    return musicGenres
        .sort((a, b) => b.search_count - a.search_count)
        .slice(0, 4);
};

const searchGenresByValue = (value, limit = 12) => {
    const uniqueNames = new Set();
    return musicGenres
        .filter((item) => {
            const name = item.name.toLowerCase();
            if (name.includes(value.toLowerCase()) && !uniqueNames.has(name)) {
                uniqueNames.add(name);
                return true;
            }
            return false;
        })
        .sort((a, b) => (b.search_count || 0) - (a.search_count || 0))
        .slice(0, limit);
};

export { getPopularGenresBySearchCount, musicGenres, searchGenresByValue };